import { Space } from "antd";
import { NavLink } from "react-router-dom";
import { env } from "../../../env/env";
import "../PrintCheckoutPage";
import emptyCart from "../../../img/shopping-cart.svg";

export function EmptyCart({ view, setView }: any) {
  return (
    <div className={"print-empty-cart-page empty-cart"}>
      <Space direction="vertical" size={"small"}>
        <h3>Your cart is empty</h3>
        <img src={emptyCart} alt={""}/>
        <NavLink
          className={"ant-btn primary ant-btn-lg"}
          to={env.dashboardPath + "/designs"}
        >
          Add Designs
        </NavLink>
      </Space>
    </div>
  );
}
